import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

axios.defaults.withCredentials = true;
Vue.use(VueAxios, axios);

// Prime Vue
import PrimeVue from 'primevue/config';
import "@/style/prime_theme.scss";
import 'primevue/resources/primevue.min.css'; //core css
import 'primeicons/primeicons.css'; //icons
import Button from 'primevue/button';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import InputText from 'primevue/inputtext';

Vue.use(ToastService);

Vue.component('Button', Button);
Vue.component('Toast', Toast);
Vue.component('InputText', InputText);

Vue.use(PrimeVue);

import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

import i18n from './i18n';
import router from './router';
import App from './App';

Vue.config.productionTip = false;

new Vue({
  el: '#profiles-pages',
  i18n,
  router,
  components: {
    App
  },
  methods: {},
  render: h => h(App)
});
